var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bike-form',{model:{value:(_vm.bike),callback:function ($$v) {_vm.bike=$$v},expression:"bike"}})}
var staticRenderFns = []

export { render, staticRenderFns }